import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import ListResponsive from "../../components/other/ListResponsive";
import LeagueRankingCard from "../../components/layout/LeagueRankingCard";
import { useNavigate } from "react-router";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { postNotification } from "../../components/utilities/Notifications";

// Want a parent component to pass in regionId and regions array. Don't render the component if there are no regions.
export default function LeaderboardsOverview(props) {
  const { region, setActiveTab, loading, embed, setLeague, organizationId } =
    props;

  const [leaderboards, setLeaderboards] = useState(null);
  const [subLoading, setSubLoading] = useState(true);

  const navigate = useNavigate();

  const handleRegionChange = async (_region) => {
    try {
      setSubLoading(true);

      const params = {
        active: true,
        "expand[]": ["gameSystem"],
      };

      if (_region?.id) {
        params.regionId = _region?.id;
      }

      if (organizationId) {
        params.gameStoreId = organizationId;
      } else {
        params.bcpDefault = true;
      }

      if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
        params.gameSystemId = getEnvironmentVariable("SINGLE_GAME_SYSTEM");
      } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
        params.gameSystemManufacturer = getEnvironmentVariable(
          "SINGLE_GAME_MANUFACTURER"
        );
      }

      const apiData = await handlePagingAll("/leagues", params);

      apiData.sort((a, b) => {
        if (
          a.gameSystem?.manufacturerOrderNum ||
          b.gameSystem?.manufacturerOrderNum
        ) {
          if (!a.gameSystem?.manufacturerOrderNum) return -1;
          if (!b.gameSystem?.manufacturerOrderNum) return 1;
          if (
            a.gameSystem?.manufacturerOrderNum !==
            b.gameSystem?.manufacturerOrderNum
          ) {
            return (
              a.gameSystem?.manufacturerOrderNum -
              b.gameSystem?.manufacturerOrderNum
            );
          }
        }
        if (
          a.gameSystem?.gameSystemOrderNum ||
          b.gameSystem?.gameSystemOrderNum
        ) {
          if (!a.gameSystem?.gameSystemOrderNum) return -1;
          if (!b.gameSystem?.gameSystemOrderNum) return 1;
          if (
            a.gameSystem?.gameSystemOrderNum !==
            b.gameSystem?.gameSystemOrderNum
          ) {
            return (
              a.gameSystem?.gameSystemOrderNum -
              b.gameSystem?.gameSystemOrderNum
            );
          }
        }

        if (!a.name && !b.name) return 0;
        if (!a.name) return -1;
        if (!b.name) return 1;

        var aVal = a.name.toUpperCase();
        var bVal = b.name.toUpperCase();

        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
      });

      const aRankingGroups = [];
      apiData.forEach((rankingGroup) => {
        if (!rankingGroup.hidePlacings) aRankingGroups.push(rankingGroup);
      });

      const tempLeaderboards = [];
      aRankingGroups.forEach((rankingGroup) => {
        tempLeaderboards.push({
          league: rankingGroup,
        });
      });

      setLeaderboards(tempLeaderboards);
    } catch (err) {
      postNotification("error", err);
    } finally {
      setSubLoading(false);
    }
  };

  useEffect(() => {
    if (region) {
      handleRegionChange(region);
    }
    // eslint-disable-next-line
  }, [region]);

  return (
    <ListResponsive
      name="Leaderboards"
      originalList={
        loading || subLoading ? null : leaderboards ? leaderboards : []
      }
      rowProps={{
        mapFunction: (row, index) => (
          <Grid key={index} item xs={12} sm={6} md={4} sx={{ p: 1 }}>
            <LeagueRankingCard
              ranking={row}
              region={region}
              onClick={() => {
                setActiveTab("truncated");
                setLeague(row.league);
                navigate(
                  `${organizationId ? "/organization" : ""}/leaderboards/${
                    organizationId ? `${organizationId}/` : ""
                  }${row.league.id}${embed ? "?embed=true" : ""}`
                );
                window.scrollTo(0, 0);
              }}
            />
          </Grid>
        ),
      }}
    />
  );
}
